import type { Activity, PendingInterrupt, RunState } from "@procurement-agents/scope-api";
import { useEffect, useState } from "react";
import { activityLabel, elapsed } from "../labels";
import { DraftView, type StreamingSection } from "../views/DraftView";
import { RequisitionView } from "../views/RequisitionView";

/** The activity view: what the agent is doing, for how long, and what exists so far. No progress bar. */
export function RunningView({ activity, pending, state, streaming, labels }: { activity: Activity; pending: PendingInterrupt | null; state: RunState | null; streaming?: Record<string, StreamingSection>; labels?: Record<string, string> }) {
  const live = streaming && Object.keys(streaming).length ? streaming : null;
  const [, tick] = useState(0);
  useEffect(() => { const t = window.setInterval(() => tick((n) => n + 1), 1000); return () => window.clearInterval(t); }, []);
  return (
    <div className="running">
      <p className="activity"><span className="pulse" aria-hidden />{activityLabel(activity, pending, state?.qa_rounds ? state.qa_rounds + 1 : undefined, state?.research_reruns)} <span className="muted small">{elapsed(activity.current_started_at)}</span></p>
      {live && <DraftView sections={Object.values(state?.sow ?? {}).filter((s) => live[s.section_id])} showQa={false} streaming={live} />}
      {!live && state?.requisition && <div className="compact"><RequisitionView req={state.requisition} full={false} labels={labels} /></div>}
    </div>
  );
}
